import dot from '../icons/dot.png';

export const SideButtons = ({ text, icon, isFirst = false, second, current, id, onClick, small, forceActiveCode, reclick, title }) => {
    const idNoNum = id.replace(/[0-9]/g, '');
    const active = current.main.replace(/[0-9]/g, '') === idNoNum || current.sub.includes(forceActiveCode) || current.sub.replace(/[0-9]/g, '') === idNoNum;
    return (
        <>
            {(isFirst && !small) && <div className="w-full h-[1px] bg-[var(--gold)]"></div>}
            {title ?
                <h4
                    onClick={() => ((reclick || !active) && onClick())}
                    className={`text-[13px] transition-colors 2xl:text-[16px] text-[var(--goldLite)] py-2 px-[56px] ${active ? `${second ? "bg-[var(--goldLite)] text-[var(--white)]" : "bg-[var(--gold)] text-[var(--white)]"} ${reclick && "cursor-pointer"}` : "cursor-pointer"}`}
                >{text}</h4> :
                <div
                    onClick={() => ((reclick || !active) && onClick())}
                    className={`flex gap-4 items-center transition-colors text-[var(--white)] px-[20px] 2xl:px-[40px] w-full ${small ? "py-1 text-[11px] 2xl:text-[13px]" : "py-2 2xl:py-4 text-[14px] 2xl:text-[16px]"} ${active ? `${second ? "bg-[var(--goldLite)]" : "bg-[var(--gold)]"} font-[800] ${reclick && "cursor-pointer"}` : "hover:bg-[var(--goldLite)] cursor-pointer"}`}
                >
                    <img className={`${icon ? "w-[25px] 2xl:w-[40px]" : "w-[6px] mx-[9.5px] 2xl:mx-[17px]"}`} src={icon || dot} />
                    {text}
                </div>
            }
            {!small && <div className="w-full h-[1px] bg-[var(--gold)]"></div>}
        </>
    )
}